import { addErrorAction } from './ErrorAction';

export const actionHelper = (actionFunction) => async (dispatch) => {
  try {
    dispatch(await actionFunction());
  } catch (error) {
    if (error?.returnCode === 'UNAUTHORIZED_ERROR') {
      //logout
    }
    if (error !== undefined && error !== 403 && error?.status !== 403) {
      dispatch(addErrorAction({ message: error?.message, code: error?.code }));
    }
  }
};

export const apiActionHelper = (apiFunction) => async (dispatch) => {
  try {
    return await apiFunction();
  } catch (error) {
    if (!error) {
      dispatch(addErrorAction({ message: 'Server error', code: 500 }));
    }
    if (error?.returnCode === 'UNAUTHORIZED_ERROR') {
      //logout
    }
    if (error !== undefined && error !== 403 && error?.status !== 403) {
      dispatch(addErrorAction({ message: error?.message, code: error?.code }));
    }
  }
};
